export const getByCode = (enumType, code) => {
    return Object.values(enumType).find((type) => type.code === `${code}`);
};
